export const pluralize = (noun, count, suffix = 's') =>
  `${count} ${noun}${count !== 1 ? suffix : ''}`;
